import { inspectionAPI } from "../../axios";

export const actions = {

    //PropertyWithdrawal
    GetSinglePropertyWithdrawal(context, data){
        return inspectionAPI.get(`PropertyWithdrawal/${data}`);
    },
    UpdatePropertyWithdrawal(context, data){
        return inspectionAPI.put(`PropertyWithdrawal/${data.id}`, data);
    },
    DeletePropertyWithdrawal(context, data){
        return inspectionAPI.delete(`PropertyWithdrawal/${data}`);
    },
    CreatePropertyWithdrawal(context, data){
        return inspectionAPI.post(`PropertyWithdrawal/CreatePropertyWithdrawal/Add`, data);
    },
    PostPropertyWithdrawal(context, data){
        return inspectionAPI.post(`PropertyWithdrawal/CreatePropertyWithdrawal/Post`, data);
    },
    ApprovedPropertyWithdrawal(context, data){
        return inspectionAPI.post(`PropertyWithdrawal/CreatePropertyWithdrawal/Approved/${data}`);
    },
    GetAvailablePropertyWithdrawal(context, data){
        return inspectionAPI.get(`Iar/Campus/Available/Withdrawal/${data}`);
    },
    GetMyAvailablePropertyWithdrawal(){
        return inspectionAPI.get(`Iar/My/Available/Withdrawal`);
    },
    GetPostedPropertyWithdrawal(context, data){
        return inspectionAPI.get(`PropertyWithdrawal/Posted/${data}`);
    },
    GetApprovedPropertyWithdrawal(context, data){
        return inspectionAPI.get(`PropertyWithdrawal/Approved/${data}`);
    },
    GetDraftPropertyWithdrawal(context, data){
        return inspectionAPI.get(`PropertyWithdrawal/Draft`);
    },
    GetMyPropertyWithdrawal(context, data){
        return inspectionAPI.get(`PropertyWithdrawal/Posted/My/${data}`);
    },
}